import React from "react"

import {
  RefinementList,
  Hits,
  Highlight,
  Pagination,
  HitsPerPage,
  ClearRefinements,
  connectStats,
  Index,
} from "react-instantsearch-dom"

import { Row, Col, Tab } from "react-bootstrap"
import { Link } from "gatsby"

import PLACEHOLDER from "../../images/wo-placeholder.png"

const algoliaIndex = process.env.GATSBY_ALGOLIA_INDEX_NAME || "Products"

const CustomStats = connectStats(
  ({ processingTimeMS, nbHits, onCountChange }) => {
    onCountChange(nbHits)
    return <></>
  }
)

const Hit = ({ hit }) => (
  <article>
    <Row>
      <div className="result-thumb">
        <a href={`${process.env.B2B_COMMERCE_BASEURL}/${hit.storeUrl}`}>
          <img
            style={{ width: "315px" }}
            src={hit.imageUrl ? hit.imageUrl : PLACEHOLDER}
            alt={hit.name}
          />
        </a>
      </div>
      <div className="result-info">
        <h5 className="headings xshort regular">
          <a
            className="black"
            href={`${process.env.B2B_COMMERCE_BASEURL}/${hit.storeUrl}`}
          >
            <Highlight attribute="name" hit={hit} />
          </a>
        </h5>

        {/*<p className="mb0">
          <strong>SKU:</strong> <Highlight attribute="sku" hit={hit} />
</p>*/}

        {/* <p className="mb0">
          <strong>Manufacturer:</strong>{" "}
          <Link to={`/${hit.manufacturerSlug}`}>
            <Highlight attribute="manufacturerName" hit={hit} />
          </Link>
        </p>

        <p className="mb0">
          <strong>Product Model #:</strong>{" "}
          <Highlight attribute="model" hit={hit} />
        </p>
        <p className="mb0">
          <strong>Product Code:</strong>{" "}
          <Highlight attribute="productCode" hit={hit} />
        </p> */}

        <p>
          <Highlight attribute="blurb" hit={hit} />
        </p>
        {/* <p className="results-viewmore">
          <Link
            to={`/product/${hit.slug}`}
            className="button secondary tiny bold caps"
          >
            $XXXXX
          </Link>
        </p> */}
      </div>
    </Row>
  </article>
)

const ProductsResults = ({ onCountChange }) => {
  return (
    <Row>
      <Index indexName={algoliaIndex}>
        {/* <Col md={3} className="search-filters">
          <h4 className="filterheader">
            <a href="">FILTER 1</a>
          </h4>

          <ul className="filterlist">
            <li>Item 1</li>
            <li>Item 2</li>
            <li>Item 3</li>
            <li>Item 4</li>
          </ul>

          <h4 className="filterheader">
            <a href="">FILTER 2</a>
          </h4>
          <ul className="filterlist">
            <li>Item 1</li>
            <li>Item 2</li>
            <li>Item 3</li>
            <li>Item 4</li>
          </ul>

          <h4 className="filterheader">
            <a href="">FILTER 3</a>
          </h4>
          <ul className="filterlist">
            <li>Item 1</li>
            <li>Item 2</li>
            <li>Item 3</li>
            <li>Item 4</li>
          </ul>
        </Col> */}
        <Col md={12}>
          {/*<div
            style={{
              display: "flex",
              alignItems: "center",
              alignSelf: "center",
            }}
          >
            <div>
              <ClearRefinements
                className="clearfilter"
                style={{ alignSelf: "center" }}
              />
            </div>

            
          </div>*/}

          <Hits hitComponent={Hit} className="prodgrid"/>
          <div style={{ marginLeft: "auto" }}>
              <CustomStats onCountChange={onCountChange} />
            </div>
            <div className="showcount" style={{ paddingLeft: "10px" }}>
              <HitsPerPage
                defaultRefinement={12}
                items={[
                  { value: 12, label: "Show 12 " },
                  { value: 50, label: "Show 50 " },
                ]}
              />
            </div>
          <br />
          <Pagination />
        </Col>{" "}
      </Index>
    </Row>
  )
}

export default ProductsResults
